<template>
  <div class="auth-description">
    <h2 class="auth-title">
      {{ $t('Sign up to Fixtender') }}
    </h2>
    <div>
      <span class="text text-grey">{{ $t('Already a member?') }}</span>
      <router-link :to="{ name: 'login', query: $router.currentRoute.query }" class="text link">
        {{ $t('Log in') }}
      </router-link>
    </div>
    <Form class="login-form auth" :success="isDone" @submit="submit">
      <FormInput
        id="name-input"
        :value="registrationInfo.name"
        required
        :max-length="32"
        :min-length="2"
        :label-text="$t('Name')"
        :placeholder="$t('Enter your name')"
        @input="
          updateRegistrationInfo({
            key: 'name',
            value: $event,
          })
        "
      />

      <FormInput
        id="email-input"
        :value="registrationInfo.email"
        type="email"
        required
        :error="!!serverErrors.email"
        :error-message="serverErrors.email"
        placeholder="e.g. john@gmail.com"
        :label-text="$t('Email')"
        @input="
          updateRegistrationInfo({
            key: 'email',
            value: $event,
          })
        "
      />
      <div class="register-passwords formcell">
        <FormInput
          id="pass-input"
          v-model="password"
          type="password"
          :error="$v.password.$error"
          :error-message="$t('At least 6 characters with number')"
          :placeholder="$t('Enter your password')"
          :input-info="$t('At least 6 characters with number')"
          :label-text="$t('Password')"
          :success="samePasswords"
        />

        <FormInput
          id="pass2-input"
          v-model="password2"
          type="password"
          :error="$v.password2.$error"
          :error-message="$t('Passwords don’t match')"
          :placeholder="$t('Repeat your password')"
          :label-text="$t('Repeat')"
          :success="samePasswords"
        />
      </div>
      <Button action-type="submit" :loading="isLoading" fill>
        {{ $t('Continue') }}
        <Icon type="arrow-right" class="ml-12" size="16" color="oncolor" />
      </Button>
    </Form>
  </div>
</template>

<script>
  import FormInput from '@/components/ui/FormInput';
  import Form from '@/components/common/Form';
  import { validationMixin } from 'vuelidate';
  import { minLength, required } from 'vuelidate/lib/validators';
  import sameAs from 'vuelidate/lib/validators/sameAs';
  import request from '@/utils/api/request';
  import { mapMutations, mapState } from 'vuex';
  import passwordValidation from '@/utils/validation';
  import Button from '@/components/ui/Button';
  import get from 'lodash.get';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'InfoRegister',
    components: {
      FormInput,
      Form,
      Button,
      Icon,
    },
    mixins: [validationMixin],
    data() {
      return {
        password: '',
        password2: '',
        isLoading: false,
        isDone: false,
        serverErrors: {
          email: null,
        },
      };
    },
    computed: {
      ...mapState('auth', ['registrationInfo']),
      samePasswords() {
        return this.$v.password.required && this.$v.password2.sameAsPassword;
      },
    },
    validations: {
      password: {
        required,
        minLength: minLength(6),
        passwordValidation,
      },
      password2: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
    methods: {
      ...mapMutations('auth', ['setRegistrationInfo', 'setPassword', 'updateRegistrationInfo']),
      async submit() {
        this.$v.$touch();
        if (this.$v.$invalid) return;

        this.isLoading = true;
        this.serverErrors = {
          email: null,
        };

        try {
          let regInfo = await request.post('/register/', {
            email: get(this.registrationInfo, 'email', ''),
            name: get(this.registrationInfo, 'name', ''),
            password: this.password,
          });

          this.isDone = true;
          this.setRegistrationInfo(regInfo.data);
          this.setPassword(this.password);
          this.$emit('change-step', 2);
        } catch (e) {
          this.serverErrors = e.response.data;
        }

        this.isLoading = false;
      },
    },
  };
</script>
